import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-36b9a664"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode("获取图片")
const _hoisted_4 = {
  key: 1,
  class: "line"
}
const _hoisted_5 = /*#__PURE__*/_createTextVNode("获取图片")
const _hoisted_6 = { class: "content" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "点击图片即可拍照", -1))
const _hoisted_8 = {
  key: 0,
  class: "mark"
}
const _hoisted_9 = { class: "photo" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "btn" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "保存至本地", -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("保存A4")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("保存A5")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("保存A6")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("保存证件")
const _hoisted_17 = { class: "dialog-footer" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("关闭")

import { onMounted, onUpdated, ref } from 'vue'
    import { HOST, PORT, PFX } from "../config/index"
    import { ElMessage } from 'element-plus'
    import axios from 'axios'
    
export default /*#__PURE__*/_defineComponent({
  props: [ 'item', 'type', 'title', 'name'],
  emits: ['callback'],
  setup(__props, { emit }) {

const props = __props

    
    
    const src = ref('')
    const srcList:any = []
    let only = true
    let corp = 0
    const dialogVisible = ref(false)
    const loadingInstance:any = ref(false)

    onMounted(() => {
      corp = 0
    })

    onUpdated(() => {
      if ( props.item && typeof props.item == 'string') {
        if ( props.item.length > 150 ) {
          setImgUrl(props.item)
        }
        // srcList.push(props.item)
        // src.value = props.item
      }
    })

    const openVideo = () => {
        dialogVisible.value = true
        loadingInstance.value = true
    }

    const handleClose = () => {
        dialogVisible.value = false
        axios.post(`${HOST}:${PORT}/stream=zoominout`, JSON.stringify({ "camidx": '0', "corp": "0" }))
    }

    const handleZoominout = async ( type:string ) => {
        let params = {
            "camidx": '0',   // 摄像头，0:主头；1:副头
            "corp": type === 'out' ? (++corp).toString() :  (--corp).toString()      // 放大比例，取值0~9，0：原图，9最大显示  
        }
        let { data } = await axios.post(`${HOST}:${PORT}/stream=zoominout`, JSON.stringify(params))
        if ( data.code === '0' ) {
            console.log(corp)
        }
    }

    let rotate = 1
    const handlerRotate =async () => {
        let params = {
            "camidx": '0',   // 摄像头，0:主头；1:副头
            "rotate": (30 * rotate).toString() // 角度，参数：90、180、270 
        }
        let { data } = await axios.post(`${HOST}:${PORT}/stream=zoominout`, JSON.stringify(params))
        if ( data.code === '0' ) {
            rotate++
        }
    }

    const imgLoading = () => {
        loadingInstance.value = false
    }

    const setImgUrl = async (url:string) => {
        src.value = `data:image/jpg;base64,${url}`
        let imgData:any = await axios.post(`/common/drawImg`, { file: src.value } );
        let imgRes = imgData.data;
        if ( imgRes.code === 200 ) {
            srcList.push(src.value)
            let { fileName } = imgRes
            emit('callback', props.name, fileName)
        }
    }

    const loading1 = ref(false)
    const loading2 = ref(false)
    const loading3 = ref(false)
    const loading4 = ref(false)

    const pos = [
        { "left": "60", "top": "30", "right": "2256", "bottom": "1789"  },
        { "left": "408", "top": "280", "right": "2214", "bottom": "1556"  },
        { "left": "669", "top": "480", "right": "1941", "bottom": "1389"  },
        { "left": "933", "top": "681", "right": "1680", "bottom": "1170"  },
    ]

    const savePhoto = async ( type: number ) => {
        let fileName = `${PFX}${new Date().getTime()}.jpg`
        let params = {
            "filepath": fileName,    // 是否保存本地，可选，为空不保存本地，否则按路径保存
            "deskew": "1",      // 纠偏（主头有效），参数：0:不纠偏；1:纠偏
            "bAutoAdjust": "1",  // 是否自动摆正： 0：不摆正 1：摆正
            ...pos[type]
        }
        switch (type) {
            case 0:
                loading1.value = true
                break;
            case 1:
                loading2.value = true
                break;
            case 2:
                loading3.value = true
                break;
            case 3:
                loading4.value = true
                break;
            default:
                break;
        }
        let { data } = await axios.post(`${HOST}:${PORT}/select=imagearea`, JSON.stringify(params))
        if ( data.code === "0" ) {
            switch (type) {
                case 0:
                    loading1.value = false
                    break;
                case 1:
                    loading2.value = false
                    break;
                case 2:
                    loading3.value = false
                    break;
                case 3:
                    loading4.value = false
                    break;
                default:
                    break;
            }
            ElMessage.success("图片保存成功:"+fileName)
        }
    }

    const scanPhoto = async ()=>{
        let data = {
            "filepath": "",
            "rotate": "0",
            "cutpage": "0",
            "camidx": "0",
            "ColorMode": "0",
            "quality": "3",
            "corp": corp.toString()
        }
        let res = await axios.post(`${HOST}:${PORT}/video=grabimage`, JSON.stringify(data))
        dialogVisible.value = false
        setImgUrl(res.data.photoBase64)
    }

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.type == 1)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "big",
          onClick: _withModifiers(openVideo, ["stop"])
        }, [
          _createVNode(_component_el_image, {
            src: src.value,
            style: {"width":"180px","height":"180px"}
          }, null, 8, ["src"]),
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(props.title) + " ", 1),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _withModifiers(openVideo, ["stop"])
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    (__props.type == 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_el_image, {
            style: {"width":"40px","height":"50px"},
            src: __props.item.imgurl,
            "preview-src-list": srcList,
            "initial-index": 1,
            fit: "cover"
          }, null, 8, ["src"]),
          _createElementVNode("span", null, _toDisplayString(props.title), 1),
          _createVNode(_component_el_button, {
            type: "primary",
            style: {"margin-right":"20px"},
            onClick: _withModifiers(openVideo, ["stop"])
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }, 8, ["onClick"]),
          (src.value)
            ? (_openBlock(), _createBlock(_component_el_image, {
                key: 0,
                src: src.value,
                style: {"width":"40px","height":"50px"},
                "preview-src-list": srcList,
                "initial-index": 1,
                fit: "cover"
              }, null, 8, ["src"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event)),
      title: "拍照",
      width: "30%",
      "before-close": handleClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_17, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: handleClose
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          (loadingInstance.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, "主摄像头加载中..."))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              id: "mainView",
              onClick: _withModifiers(scanPhoto, ["stop"]),
              onLoad: imgLoading,
              src: "http://127.0.0.1:38088/video=stream&camidx=0",
              alt: "主摄像头"
            }, null, 40, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _hoisted_12,
              _createElementVNode("div", null, [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  loading: loading1.value,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (savePhoto(0)), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  loading: loading2.value,
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (savePhoto(1)), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  loading: loading3.value,
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (savePhoto(2)), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "small",
                  loading: loading4.value,
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (savePhoto(3)), ["stop"]))
                }, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})